import type { NextPage } from "next";
import PageLayout from "../components/PageLayout";

import useLedgerCookies from "@hooks/useLedgerCookies";
import BridgeWrap from "@components/BridgeWrap/BridgeWrap";
import { BW_VARIANT } from "@components/BridgeWrap/types";
// import Wrap from "@components/Wrap";

const WrapPage: NextPage = () => {
  useLedgerCookies();
  return (
    <PageLayout>
      <BridgeWrap variant={BW_VARIANT.RSETH} />
    </PageLayout>
  );
};

export default WrapPage;
